import { RESET_ALL_STATE, SET_ICP_HISTORY_RESULT } from './actions';

function areSegmentsEqual(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  return a.every((seg, idx) => seg.segment_id === b[idx]?.segment_id);
}

const initialState = {
  icpHistory: [],
  pagination: 0,
  selectedIcp: null,
  loading: false,
  error: null,
  selectedSegment: null,
  activeStep: 0,
  websiteUrl: '',
  segments: [],
  customerTypes: {},
  core_segmentation_model: null,
  task_id: null,
  generatedICP: null,
  icpLoading: false,
  historyResult: null
};

const icpReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ICP_SEGMENTS': {
      // console.log('Reducer handling payload:', action.payload);

      const customerTypes = action.payload.segments.reduce((acc, segment) => {
        if (segment.customer_type) {
          acc[segment.segment_id] = segment.customer_type.toLowerCase();
        }
        return acc;
      }, {});

      return {
        ...state,
        segments: action.payload.segments,
        customerTypes,
        websiteUrl: action.payload.websiteUrl,
        core_segmentation_model: action.payload.core_segmentation_model,
        task_id: action.payload.task_id,
        loading: false,
        error: null
      };
    }
    case 'SET_SELECTED_SEGMENT':
      return {
        ...state,
        selectedSegment: action.payload
      };
    case 'SET_ACTIVE_STEP':
      return {
        ...state,
        activeStep: action.payload
      };
    case 'SET_ICP_LOADING':
      return {
        ...state,
        loading: action.payload
      };
    case 'SET_ICP_ERROR':
      return {
        ...state,
        error: action.payload
      };
    case RESET_ALL_STATE:
      return initialState;
    case 'RESET_ICP_REDUCER':
      return {
        ...initialState,
        icpHistory: state.icpHistory, // Preserve history list
        pagination: state.pagination // Preserve pagination
      };
    case 'CREATE_ICP_REQUEST':
      return {
        ...state,
        icpLoading: true,
        error: null
      };
    case 'CREATE_ICP_SUCCESS':
      return {
        ...state,
        generatedICP: {
          ...(state.generatedICP || {}),
          [action.payload.segmentId]: action.payload.icp
        },
        icpLoading: false,
        error: null
      };
    case 'CREATE_ICP_FAILURE':
      return {
        ...state,
        icpLoading: false,
        error: action.payload
      };
    case 'SET_ICP_HISTORY':
      return {
        ...state,
        icpHistory: action.payload
      };
    case 'SET_ICP_PAGINATION':
      return {
        ...state,
        pagination: action.payload
      };
    case SET_ICP_HISTORY_RESULT: {
  
      
      const historyCustomerTypes =
        action.payload.customer_types ||
        (action.payload.segmentation?.final_segments || []).reduce((acc, segment) => {
          if (segment.customer_type) {
            acc[segment.segment_id] = segment.customer_type.toLowerCase();
          }
          return acc;
        }, {});

      const newSegments = action.payload.segmentation?.final_segments || [];
      const newState = {
        ...state,
        websiteUrl: action.payload.url,
        segments: newSegments,
        customerTypes: historyCustomerTypes,
        core_segmentation_model: action.payload.segmentation?.core_segmentation_model,
        selectedSegment:
          !areSegmentsEqual(state.segments, newSegments)
            ? newSegments[0] || null
            : state.selectedSegment,
        generatedICP: action.payload.icps,
        selectedIcp: action.payload.icps?.segment_1 || null,
        activeStep: action.payload.icps ? 2 : action.payload.segmentation ? 1 : 0,
        task_id: action.payload.task_id
      };
      

      return newState;
    }
    default:
      return state;
  }
};

export default icpReducer;
